// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3Nmgb","inner":"Form_inner__1z-0y","range":"Form_range__1cR5p","name":"Form_name__KBIYK","actions":"Form_actions__2F_4p"};